import {
  ChangeDetectionStrategy,
  Component,
  ComponentRef,
  inject,
  OnInit,
  signal,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { A11yModule } from '@angular/cdk/a11y';
import { PopupData } from './popup.models';
import { SpinnerComponent } from '../az-spinner/spinner.component';

@Component({
  selector: 'app-popup-container',
  templateUrl: './popup-container.component.html',
  styleUrl: './popup-container.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [A11yModule, MatIcon, SpinnerComponent],
})
export class PopupContainerComponent implements OnInit {
  readonly data = inject<PopupData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(MatDialogRef<PopupContainerComponent>);

  @ViewChild('contentHost', { read: ViewContainerRef, static: true })
  contentHost!: ViewContainerRef;

  private contentRef: ComponentRef<unknown> | null = null;

  frozen = signal(false);

  ngOnInit(): void {
    this.frozen.set(this.data.freeze ?? false);

    if (this.data.component) {
      this.contentRef = this.contentHost.createComponent(this.data.component);

      if (this.data.componentInputs) {
        for (const [key, value] of Object.entries(this.data.componentInputs)) {
          this.contentRef.setInput(key, value);
        }
      }
    }
  }

  onConfirm(): void {
    if (this.frozen()) return;
    const instance = this.contentRef?.instance as
      | { getValue?: () => unknown }
      | undefined;
    const value = instance?.getValue ? instance.getValue() : true;
    this.dialogRef.close(value);
  }

  onCancel(): void {
    if (this.frozen()) return;
    this.dialogRef.close(this.data.cancelResult);
  }

  onCloseX(): void {
    if (this.frozen()) return;
    this.dialogRef.close();
  }
}
